export default __webpack_public_path__ + "static/media/icon-upload.7a368cd1.svg";